import type { Organization } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn } from "@tudigo-monorepo/core-tudigo-theme";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { BadgeRebrand } from "@tudigo-monorepo/web-tudigo-components";

export function ParticipationOrganizationTypeBadge({
  type,
  className,
}: {
  type: Organization["type"];
  className?: string;
}) {
  const { t } = useTranslation();

  return (
    <BadgeRebrand
      variant="secondary"
      className={cn("w-fit whitespace-nowrap", className)}
    >
      {t(`participations.web_app.participations_list_page.${type}`)}
    </BadgeRebrand>
  );
}
